<ion-content class="ion-padding">
  <ion-grid>
    <ion-row class="ion-justify-content-center">
      <ion-col size-lg="3" size-md="5" size-sm="10" class="ion-margin-vertical">
        <ion-img src="/assets/akpr_logo.svg"></ion-img>
      </ion-col>
    </ion-row>
    <ion-row class="ion-justify-content-center">
      <ion-col size-lg="4" size-md="5" size-sm="10">
        <form [formGroup]="recoveryForm">
          <ion-list>
            <ion-item>
              <ion-label position="stacked">Email</ion-label>
              <ion-input formControlName="email" type="text"> </ion-input>
            </ion-item>
          </ion-list>
        </form>
      </ion-col>
    </ion-row>
    <ion-row class="ion-justify-content-center">
      <ion-col size-lg="4" size-md="5" size-sm="10">
        <ion-button
          (click)="recover()"
          color="primary"
          shape="full"
          expand="block"
          class="submit-btn"
          >Submit</ion-button
        >
      </ion-col>
    </ion-row>
    <ion-row class="ion-justify-content-center">
      <ion-col size-lg="4" size-md="5" size-sm="10">
        <a [routerLink]="['/auth/login']">Back to sign in</a>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
